<div class="flex items-center w-full" [class.ml-4]="showToggle" [class.justify-between]="showToggle"
    [class.justify-center]="!showToggle" [class.mr-2]="!showToggle">
    <div class="branding flex items-center p-2 h-14 w-full relative overflow-hidden">
        <!-- Logo completo -->
        <app-logo width="180px" type="w-full" 
            class="transition-all duration-300 transform-gpu"
            [ngClass]="collapsed ? 'opacity-0 -translate-x-10 invisible scale-95' : 'opacity-100 translate-x-0 visible scale-100'"></app-logo>
        
        <!-- Icono compacto -->
        <app-logo width="35px" type="icon" 
            class="absolute left-1/2 -translate-x-1/2 transition-all duration-300 transform-gpu"
            [ngClass]="collapsed ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-50 invisible'"></app-logo>
    </div>

    @if(showToggle) {
    <button (click)="emit()"
        class="flex items-start justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition mr-3">
        <span class="iconify text-xl" data-icon="solar:close-circle-outline" data-inline="false"></span>
    </button>
    }
</div>